export const createUrl = (siteName: string, hidePanels: boolean) =>
  hidePanels
    ? `/#/${siteName}/Scheduler2?hidePanels=true`
    : `/#/${siteName}/Scheduler2`;
